import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=687a29f7&scoped=true"
import script from "./button.js?vue&type=script&lang=js&external"
export * from "./button.js?vue&type=script&lang=js&external"
import style0 from "./button.scss?vue&type=style&index=0&id=687a29f7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a29f7",
  null
  
)

export default component.exports